var map = {
	"./0x0000000000000000000000000000000000000000.svg": 1060,
	"./0x1e991ea872061103560700683991a6cf88ba0028.svg": 1061,
	"./0x4c888e116d57a32f84865f3789dcb131fdc9fab6.svg": 1062,
	"./0xaa9e582e5751d703f85912903bacaddfed26484c.svg": 1063,
	"./0xbb10c3ba37b4da01a70d6f3f456c5323a11a76fb.svg": 1064,
	"./0xbbe47167666100ec33de9079c1ee7b150ccbd874.svg": 1065,
	"./0xc778417e063141139fce010982780140aa0cd5ab.svg": 1066,
	"./0xc7ad46e0b8a400bb3c915120d284aafba8fc4735.svg": 1067,
	"./0xcd1faff6e578fa5cac469d2418c95671ba1a62fe.svg": 1068,
	"./0xd3c325848d7c6e29b574cb0789998b2ff901f17e.svg": 1069,
	"./0xe1604b54cac27970aa67b4e38495f206b59cee42.svg": 1070,
	"./0xe2a59d5e33c6540e18aaa46bf98917ac3158db0d.svg": 1071,
	"./1art.svg": 1072,
	"./_default.svg": 16,
	"./_default_nft.svg": 118,
	"./avax.svg": 1073,
	"./bnb.svg": 1074,
	"./busd.svg": 1075,
	"./cirus.svg": 1076,
	"./dai.svg": 1077,
	"./default.svg": 1078,
	"./eth.svg": 1079,
	"./hai.svg": 1080,
	"./link.svg": 1081,
	"./matic.svg": 1082,
	"./niftsy.svg": 1083,
	"./plasma.svg": 1084,
	"./pos.svg": 1085,
	"./sca.svg": 1086,
	"./techniftsy.svg": 1087,
	"./ufi.svg": 1088,
	"./usdc.svg": 1089,
	"./usdt.svg": 1090,
	"./venvlp.svg": 1091,
	"./weth.svg": 1092,
	"./xtm.svg": 1093
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 230;